const IconosquareChristmas = () => {
    return (
        <img
            className="-ml-[7px] -mt-[10px] w-[30px] max-w-[30px]"
            src="/images/home/logo-christmas.png"
            alt="Logo Iconosquare Christmas"
        />
    );
};

export default IconosquareChristmas;
